import { Type } from "@sinclair/typebox";
import { Sha256Schema } from "./shared.js";
const ThreadIdSchema = Type.String({
    pattern: "^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$",
});
/** 仅传递原生线程定位及乐观版本，不通过 IPC 搬运 SDK 内部文件。 */
export const CodexStateBindingSchema = Type.Object({
    contextKey: Sha256Schema,
    revision: Type.Integer({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER - 1 }),
    threadId: Type.Optional(ThreadIdSchema),
}, { additionalProperties: false });
export const CodexThreadStateSchema = Type.Object({
    contextKey: Sha256Schema,
    revision: Type.Integer({ minimum: 1, maximum: Number.MAX_SAFE_INTEGER }),
    threadId: ThreadIdSchema,
}, { additionalProperties: false });
//# sourceMappingURL=codex-state.js.map